import { Application, KsaOnboarding, Stage } from '~/types/Application';
import { AuthorizedRepresentativeSendInvitationPayload } from '~/types/AuthorizedRepresentativeSendInvitationPayload';
import { CanSubmitCompleteReviewResponse } from '~/types/ksa/KsaReviewResult';
import axios from './axios';

// import application from './mock/application.json';

export const getApplication = () => {
  // return Promise.resolve<Application>(application as any as Application);
  return axios.get<Application>('/merchant/application').then((res) => res.data);
};

export const selectStage = (stage: Stage) => {
  return axios
    .get<Application>('/agent/application', { params: { stage } })
    .then((res) => res.data);
};

export const getFlows = () => {
  return axios.get<KsaOnboarding>('/merchant/flows').then((res) => res.data);
};

export const previewApplication = (stage: Stage) => {
  return axios
    .get<Application>('/agent/application', { params: { stage } })
    .then((res) => res.data);
};

export const selectStep = (body: { stageKey?: string; stepKey: string }) => {
  return axios.post<Application>('/stages/wizard/selectStep', body).then((res) => res.data);
};

export const submitStep = (stepData?: any) => {
  return axios.post<Application>('/stages/wizard/submitStep', { stepData }).then((res) => res.data);
};

export const saveStep = (stepData?: any) => {
  return axios.post<Application>('/stages/wizard/saveStep', { stepData }).then((res) => res.data);
};

export const setApplicationStage = (stage: any) => {
  return axios
    .post<Application>('/application/setApplicationStage', stage, {
      headers: { 'Content-Type': 'text/plain' },
    })
    .then((res) => res.data);
};

export const submitSalesforceTechnicalError = () => {
  return axios.post<Application>('/stages/salesforceTechnicalError/submit').then((res) => res.data);
};

export const submitSalesforceError = () => {
  return axios.post<Application>('/stages/salesforceError/submit').then((res) => res.data);
};

export const softDeclineGoFixApplication = () => {
  return axios.post<Application>('/stages/salesforceSoftDecline').then((res) => res.data);
};

export const sendInvitation = (body: AuthorizedRepresentativeSendInvitationPayload) => {
  return axios.post<void>('/stages/fillApplication/sendInvitation', body);
};

export const salesforceErrorReturnToFillApplication = () => {
  return axios
    .post<Application>('/stages/salesforceError/returnToFillApplication')
    .then((res) => res.data);
};

export const salesforceTechnicalErrorReturnToFillApplication = () => {
  return axios
    .post<Application>('/stages/salesforceTechnicalError/returnToFillApplication')
    .then((res) => res.data);
};

export const canSubmitCompleteReview = () => {
  return axios
    .get<CanSubmitCompleteReviewResponse>('/stages/wizard/canSubmitCompleteReview')
    .then((res) => res.data);
};
